enum TipoGradeHorarioEnum {
  ReservadoParaOMedico = 'Reservado ao médico',
  UtilizadoPeloMedico = 'Utilizado pelo médico',
  PrecisaDeConfirmacaoDoAgendamento = 'Necessita confirmação',
  Indisponivel = 'Indisponivel',
}

export default TipoGradeHorarioEnum
